// Campus photo for /colleges/clark-university: CC BY-SA 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AClark_University_campus_scene%2C_Worcester_Massachusetts.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/clark-university/; credited under the photo.
const photo = {
    "slug": "clark-university",
    "alt": "Brick residence halls along a walkway with Clark banners at Clark University in Worcester, Massachusetts",
    "src": "/colleges/clark-university/campus-1600.webp",
    "srcSmall": "/colleges/clark-university/campus-800.webp",
    "srcMid": "/colleges/clark-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/clark-university/og.jpg",
    "title": "Clark University campus scene, Worcester Massachusetts",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AClark_University_campus_scene%2C_Worcester_Massachusetts.jpg",
    "read": "2026-10-01"
};

export default photo;
